import { render, staticRenderFns } from "./AccountingReportsComponent.vue?vue&type=template&id=0c4d428e&"
import script from "./AccountingReportsComponent.vue?vue&type=script&lang=js&"
export * from "./AccountingReportsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports